import style from './services.module.css'
import imageService from '../../images/services.jpg'
import imageGame from '../../images/game.jpg'
import imageWeb from '../../images/webD.jpg'
import React from 'react'
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';

const Services = ({visibleElements, elementsRef}) => {
    return (
        <section id='services' className={style['services']}
        ref={(el) => (elementsRef.current[9] = el)}>

            <div className={`${style['services__container']}
            ${style['services__container--has-background-color']}`}>

                <h2 className={`${style['services__title']} 
                    ${visibleElements.includes(elementsRef.current[10]) ?
                        style['services__title--transition'] : ''}`}>
                    Nuestros Servicios.
                </h2>

                <div className={style['services__section']}
                    ref={(el) => (elementsRef.current[10] = el)}>

                    <h3 className={`${style['services__subtitle']} 
                    ${visibleElements.includes(elementsRef.current[10]) ?
                            style['services__subtitle--transition'] : ''}`}>
                        Soluciones digitales a la medida: desarrollo web y videojuegos indie.
                    </h3>

                    <p className={`${style['services__description']}
                    ${visibleElements.includes(elementsRef.current[10]) ?
                            style['services__description--transition'] : ''}`}>
                        En BrokenDev, nos especializamos en el desarrollo de soluciones
                        digitales innovadoras. Ya sea que necesites una página web moderna
                        o quieras probar uno de nuestros videojuegos indie.
                    </p>

                </div>

                <div className={style['services__section']}
                    ref={(el) => (elementsRef.current[11] = el)}>

                    <img src={imageService} alt='Imagen de servicios'
                        className={`lazyload ${style['services__image']}
                    ${style['services__image--transition-one']} 
                    ${visibleElements.includes(elementsRef.current[11]) ?
                                style['services__image--transition-one-active'] : ''}`} />

                </div>

            </div>

            <div className={`${style['services__container']}
            ${style['services__container--has-background-degraded']}`}>

                <div className={style['services__section']}
                    ref={(el) => (elementsRef.current[12] = el)}>

                    <img src={imageWeb} alt='Imagen de desarrollo web'
                        className={`lazyload ${style['services__image']} 
                    ${style['services__image--transition-two']} 
                    ${visibleElements.includes(elementsRef.current[12]) ?
                                style['services__image--transition-two-active'] : ''}`} />

                </div>

                <div className={style['services__section']}
                    ref={(el) => (elementsRef.current[13] = el)}>

                    <h2 className={`${style['services__subtitle']} 
                    ${visibleElements.includes(elementsRef.current[13]) ?
                            style['services__subtitle--transition'] : ''}`}>
                        Desarrollo Web:
                    </h2>

                    <p className={`${style['services__description']} 
                    ${visibleElements.includes(elementsRef.current[13]) ?
                            style['services__description--transition'] : ''}`}>
                        Creamos páginas web personalizadas y funcionales, adaptadas a las necesidades de cada negocio. Utilizamos tecnologías modernas como React, HTML5, CSS3 y JavaScript para asegurar una experiencia de usuario excelente.
                    </p>

                </div>

                <div className={style['services__section']}
                    ref={(el) => (elementsRef.current[14] = el)}>

                    <h2 className={`${style['services__subtitle']} 
                    ${visibleElements.includes(elementsRef.current[14]) ?
                            style['services__subtitle--transition'] : ''}`}>
                        Desarrollo de Videojuegos Indie:
                    </h2>

                    <p className={`${style['services__description']} 
                    ${visibleElements.includes(elementsRef.current[14]) ?
                            style['services__description--transition'] : ''}`}>
                        Desarrollamos videojuegos indie que destacan por su creatividad y jugabilidad. Trabajamos desde la idea inicial hasta la publicación del juego, asegurándonos de que cada detalle sea perfecto.
                    </p>

                </div>

                <div className={style['services__section']}
                    ref={(el) => (elementsRef.current[15] = el)}>

                    <img src={imageGame} alt='Imagen de Bowler Adventure'
                        className={`lazyload ${style['services__image']} 
                    ${style['services__image--transition-three']} 
                    ${visibleElements.includes(elementsRef.current[15]) ?
                                style['services__image--transition-three-active'] : ''}`} />

                </div>

            </div>

        </section>
    )
};

export default Services;
